import adminApiFetch from './apiService';

const productLabelTemplateService = {
  // Get product label templates list (for search)
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.limit) queryParams.append('limit', params.limit);

    const res = await adminApiFetch(`product_label_templates?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },

  // Get product label templates list (for table)
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('product_label_templates/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // Get all product label template IDs (for filtering)
  getIds: async (params = {}) => {
    const res = await adminApiFetch('product_label_templates/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // Get single product label template
  get: async (id) => {
    const res = await adminApiFetch(`product_label_templates/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // Get single product label template (alias)
  getById: async (id) => {
    return productLabelTemplateService.get(id);
  },

  // Create product label template
  create: async (data) => {
    const res = await adminApiFetch('product_label_templates', {
      method: 'POST',
      body: { product_label_template: data }
    });
    return res.json();
  },

  // Update product label template
  update: async (id, data) => {
    const res = await adminApiFetch(`product_label_templates/${id}`, {
      method: 'PUT',
      body: { product_label_template: data }
    });
    return res.json();
  },

  // Delete product label template
  delete: async (id) => {
    const res = await adminApiFetch(`product_label_templates/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  },

  // Get default liquid template
  getDefaultTemplate: async () => {
    const res = await adminApiFetch('product_label_templates/default_template', {
      method: 'GET'
    });
    return res.json();
  }
};

export { productLabelTemplateService };
export default productLabelTemplateService;
